import Styles from '../../Styles.module.scss';
import Kill from './Kill';
import Login from './Login';
import Logout from './Logout';
import Logs from './Logs';
import Ls from './Ls';
import Run from './Run';
import Serve from './Serve';
import Status from './Status';
import Stop from './Stop';
import Version from './Version';

export function Commands() {
    return (
        <div className={Styles.Section}>
            <h2 className={Styles.SectionTitle}>Commands</h2>
            <p className={Styles.SectionDescription}>
                Complete reference for all CLI commands. Use <code>modelpark --help</code> to see available commands.
            </p>

            <div className={Styles.CommandsList}>
                <Run />
                <Serve />
                <Ls />
                <Logs />
                <Stop />
                <Kill />
                <Login />
                <Logout />
                <Status />
                <Version />
            </div>
        </div>
    );
}
